"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteDisabledComponent = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const autocomplate_styles_1 = require("./autocomplate-styles");
function AutocompleteDisabledComponent(props) {
    var _a;
    const classes = (0, autocomplate_styles_1.useStyles)();
    const values = (_a = props.value) === null || _a === void 0 ? void 0 : _a.split('; ');
    return (react_1.default.createElement(react_1.default.Fragment, null, values === null || values === void 0 ? void 0 : values.map((value) => (react_1.default.createElement(Typography_1.default, { key: value, variant: "body1", className: classes.disabledComponent }, value)))));
}
exports.AutocompleteDisabledComponent = AutocompleteDisabledComponent;
//# sourceMappingURL=autocomplete-disabled-component.js.map